import React from "react";

export default function Hero() {
	return (
		<div className="min-h-screen bg-white overflow-hidden pt-16 md:pt-0">
			<div className="relative h-screen flex items-center">
				{/* Background Elements */}
				<div className="absolute inset-0 z-0">
					<div className="absolute top-0 right-0 w-3/4 h-screen bg-gradient-to-bl from-purple-50 to-pink-50 rounded-bl-[30%]"></div>
					<div className="absolute -top-20 -right-20 w-96 h-96 rounded-full bg-gradient-to-r from-purple-200 to-pink-200 opacity-50"></div>
					<div className="absolute bottom-20 right-1/4 w-64 h-64 rounded-full bg-gradient-to-r from-purple-100 to-pink-100 opacity-40"></div>
					<div className="absolute top-1/3 left-2/3 w-40 h-40 rounded-full bg-gradient-to-r from-purple-300 to-pink-300 opacity-30"></div>

					{/* Diagonal lines */}
					<div className="absolute top-0 left-0 w-full h-full overflow-hidden">
						<div className="absolute top-1/4 left-0 w-full h-px bg-gradient-to-r from-transparent via-purple-300 to-transparent transform -rotate-6"></div>
						<div className="absolute top-1/2 left-0 w-full h-px bg-gradient-to-r from-transparent via-pink-300 to-transparent transform -rotate-6"></div>
						<div className="absolute top-3/4 left-0 w-full h-px bg-gradient-to-r from-transparent via-purple-300 to-transparent transform -rotate-6"></div>
					</div>

					{/* Dot pattern */}
					<div className="absolute inset-0 opacity-20">
						<div className="h-full w-full grid grid-cols-12 grid-rows-12">
							{Array(144)
								.fill()
								.map((_, i) => (
									<div
										key={i}
										className="flex items-center justify-center"
									>
										<div className="w-1 h-1 rounded-full bg-gray-400"></div>
									</div>
								))}
						</div>
					</div>
				</div>

				{/* Content Container */}
				<div className="container mx-auto px-6 md:px-12 z-10 flex flex-col md:flex-row items-center mt-16 md:mt-0">
					{/* Left Content */}
					<div className="md:w-1/2 md:pr-12">
						<div className="relative">
							<div className="absolute -left-6 -top-6 w-20 h-20">
								<div className="w-full h-full border-t-2 border-l-2 border-purple-500"></div>
							</div>

							<h1 className="text-5xl pb-4 md:text-6xl lg:text-7xl font-black bg-gradient-to-r from-purple-600 to-pink-500 bg-clip-text text-transparent mb-2">
								Deera Graphics
							</h1>

							<div className="absolute -right-6 -bottom-6 w-20 h-20">
								<div className="w-full h-full border-b-2 border-r-2 border-pink-500"></div>
							</div>
						</div>

						<p className="py-6 text-2xl md:text-3xl italic text-gray-700">
							Taking the tech industry's graphics to next level.
						</p>

						<div className="w-32 h-1 bg-gradient-to-r from-purple-600 to-pink-500 rounded-full mb-6"></div>

						<p className="text-lg text-gray-700 mb-8">
							Just drop a message at{" "}
							<a
								href="tel:+91-9716609422"
								className="font-bold relative inline-block group"
							>
								<span className="bg-gradient-to-r from-purple-600 to-pink-500 bg-clip-text text-transparent">
									(+91)-9716609422
								</span>
								<span className="absolute bottom-0 left-0 w-full h-0.5 bg-gradient-to-r from-purple-600 to-pink-500 transform scale-x-0 transition-transform duration-300 group-hover:scale-x-100"></span>
							</a>{" "}
							to request a callback.
						</p>

						<div className="flex space-x-4">
							<button className="px-6 py-3 bg-gradient-to-r from-purple-600 to-pink-500 text-white font-bold rounded-lg shadow-md hover:shadow-lg transition-shadow">
								Get Started
							</button>
							<button className="px-6 py-3 bg-white text-gray-700 font-bold rounded-lg shadow-md hover:shadow-lg border border-gray-200 transition-shadow">
								Our Portfolio
							</button>
						</div>
					</div>

					{/* Right Content - Geometric Design */}
					<div className="md:w-1/2 mt-12 md:mt-0 flex justify-center">
						<div className="relative w-80 h-80">
							{/* Main circle */}
							<div className="absolute inset-0 rounded-full bg-gradient-to-br from-purple-500 to-pink-500 opacity-10"></div>

							{/* Inner circle */}
							<div className="absolute inset-8 rounded-full bg-gradient-to-tr from-purple-500 to-pink-500 opacity-20"></div>

							{/* Center circle */}
							<div className="absolute inset-16 rounded-full bg-gradient-to-r from-purple-500 to-pink-500 opacity-30"></div>

							{/* Floating elements */}
							<div className="absolute -top-10 -right-10 w-24 h-24 rounded-lg bg-purple-500 opacity-20 transform rotate-12"></div>
							<div className="absolute -bottom-12 left-10 w-20 h-20 rounded-lg bg-pink-500 opacity-20 transform -rotate-12"></div>
							<div className="absolute top-1/4 -left-12 w-16 h-16 rounded-full bg-purple-400 opacity-20"></div>

							{/* Overlapping semi-transparent shapes */}
							<div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-40 h-40">
								<svg
									viewBox="0 0 100 100"
									className="w-full h-full"
								>
									<path
										d="M50 0 L100 50 L50 100 L0 50 Z"
										fill="url(#grad1)"
										opacity="0.7"
									/>
									<defs>
										<linearGradient
											id="grad1"
											x1="0%"
											y1="0%"
											x2="100%"
											y2="100%"
										>
											<stop
												offset="0%"
												stopColor="#8B5CF6"
											/>
											<stop
												offset="100%"
												stopColor="#EC4899"
											/>
										</linearGradient>
									</defs>
								</svg>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
